import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)

//Modulos de autenticação e login
import pages from "./pages";
import login from "./login";
import loader from "./loader";
import service from "./service";
import animals from "./animals";
import creators from "./creators";
import farms from "./farms";
import partners from "./partners";
import events from "./events";
import sidebar from "./sidebar";
import milk_control from "./milk-control";
import localization from "./localization";
import closures from "./closures";
import birth_consultation from "./birth_consultation";
//Final dos modulos de autenticação e login

/* Inicio dos modulos de relatorios */
import reports_schema from "./reports";
import services_report from "./service-report";
import validated_services_report from "./validated-services-report";
import report_ril from "./report-ril";
import milk_analysis_report from "./milk-analysis-report";
import interpolation_report from "./interpolation-report";
import rmpi_report from "./rmpi-report";
import lactation_curve from "./lactation-curve";
import production_record_report from "./production-record-report";
import production_record_report_single from "./production-record-report-single";
import r2 from "./r2";
import milk_extractions_report from "./milk-extractions-report";
/* Final dos modulos de relatorios */

export default new Vuex.Store({
  modules: {
    login,
    loader,
    service,
    animals,
    creators,
    farms,
    partners,
    events,
    sidebar,
    services_report,
    reports_schema,
    milk_control,
    validated_services_report,
    pages,
    report_ril,
    milk_analysis_report,
    interpolation_report,
    rmpi_report,
    lactation_curve,
    localization,
    closures,
    production_record_report,
    production_record_report_single,
    birth_consultation,
    r2,
    milk_extractions_report
  }
})
